import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextField, Checkbox } from 'redux-form-material-ui';
import { Form, Field, reduxForm, formValueSelector, submit } from 'redux-form/immutable';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import _ from 'lodash';

import AlertDialog from '../../Common/AlertDialog';
import ReduxDialog from '../../Common/ReduxDialog';
import { addTenantFormHandler, fetchStaticRoutine } from '../../../routines';
import { toArray } from '../../../utils/helper';
import { required } from '../../../utils/formvalidation';
import { showError, isDialogOpen, showDialog, hideDialog } from '../../../actions/dialogs';

import styles from './styles';

class AddTenantDialog extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    fetchIndustries: PropTypes.func.isRequired,

    dialogs: PropTypes.object.isRequired,
    showError: PropTypes.func.isRequired,

    acceptedTAC: PropTypes.bool,
  };

  state = {
    message: '',
  };

  componentWillMount() {
    this.props.fetchIndustries();
  }

  render() {
    const { handleSubmit, submit } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('addTenant')}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        type="submit"
        onClick={() => submit('addtenant')}
      />,
    ];

    return (
      <ReduxDialog
        name="addTenant"
        title="Create Account"
        actions={actions}
        modal={false}
        onRequestClose={() => this.props.onRequestClose()}
        bodyStyle={styles.body}
      >
        <Paper style={styles.paper} zDepth={5}>
          <Form style={styles.form} onSubmit={handleSubmit(addTenantFormHandler)}>
            <div style={styles.row}>
              <Field
                name="company"
                component={TextField}
                type="text"
                style={styles.input}
                fullWidth
                floatingLabelFixed
                floatingLabelText="Company"
                validate={[required]}
              />
              {/*<Field*/}
                {/*name="industryId"*/}
                {/*component={SelectField}*/}
                {/*style={styles.input}*/}
                {/*fullWidth*/}
                {/*floatingLabelFixed*/}
                {/*floatingLabelText="Industry"*/}
                {/*validate={[required]}*/}
              {/*>*/}
                {/*{ industries.map((industry) => <MenuItem*/}
                  {/*key={industry.id}*/}
                  {/*value={industry.id}*/}
                  {/*primaryText={industry.name}/>)}*/}
              {/*</Field>*/}
            </div>

            <div style={styles.row}>
              <Field
                name="acceptedTAC"
                component={Checkbox}
                labelStyle={{ zIndex: 3 }}
                label={<span>I accept the <a href="https://staza.io/terms-service.html" rel="noopener noreferrer" target="_blank">terms and conditions</a></span>}
                validate={[required]}
              />
            </div>
          </Form>
        </Paper>
        { isDialogOpen(this.props.dialogs, 'alert') ? <AlertDialog /> : null }
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'addtenant',  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog('addTenant');
  },
  onSubmitFail: (errors, dispatch, submitError) => {
    console.log('AddTenant - onSubmitFail', errors);
    if (_.keys(errors).length > 0) {
      dispatch(showError('Account Creation Failed', 'Please complete all mandatory fields'));
    } else {
      dispatch(showError('Account Creation Failed', 'Unknown error'));
    }

  },
})(AddTenantDialog);

function mapStateToProps(state) {
  const selector = formValueSelector('addtenant');
  return {
    dialogs: state.getIn(['dialogs', 'dialogs']).toJS(),
    industries: toArray(state.get('static').get('industries').toJS()),
    acceptedTAC: selector(state, 'acceptedTAC'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dispatch,
    showDialog,
    hideDialog,
    fetchIndustries: () => fetchStaticRoutine.trigger({ type: 'industries' }),
    showError,
    submit,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/AddTenantDialog/index.js